import { ok } from '@xlearn/common';
import { SimpleModel } from '../schema-engine/handler';

export function getStudentInfo(data: SimpleModel) {
  return ok(data)
}
